import { render, staticRenderFns } from "./BlockedClients.vue?vue&type=template&id=28ceba4e&"
import script from "./BlockedClients.vue?vue&type=script&lang=ts&"
export * from "./BlockedClients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports